import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from "@angular/material/dialog";
import { ToastrService } from "ngx-toastr";
import { DeletePopupComponent } from "../../../shared/components/delete-popup/delete-popup.component";
import { AssessmentCentralService } from "../../../shared/services/assessment-central.service";
import { AssessmentPreviewModalDialogComponent } from "../../../pages/kepler/assessment-central/assessment-templates/assessment-templates.component";
import { AssessmentCreateModalDialogComponent } from "../../../pages/kepler/assessment-central/assessment-templates/assessment-create-modal/assessment-create-modal";
import { NgxSpinnerService } from "ngx-spinner";
import textConfiguration from "../../../../assets/static-text-configuration.json";
import { AssessmentTemplateEditDialogComponent } from "../assessment-template-edit-dialog/assessment-template-edit-dialog.component";
@Component({
  selector: "app-assessment-library",
  templateUrl: "./assessment-library.component.html",
  styleUrls: ["./assessment-library.component.scss"],
})
export class AssessmentLibraryComponent implements OnInit {
  @Input() isDataLoaded: any;
  @Input() filteredTemplate: any;
  @Input() unCategorizedTemplates: any;
  @Input() showTip: any = true;
  @Input() showCategoryToggle: any = true;
  @Input() openFrom: any = "assessment-central";
  @Output() templateDeleted = new EventEmitter<any>();
  commonText: any = (textConfiguration as any).common;
  isCategoryView = false;
  filterAppliedStatus = false;
  templates: any = [];
  templatesLoaded = false;

  constructor(
    private readonly dialog: MatDialog,
    private readonly assessmentCentralService: AssessmentCentralService,
    private readonly toastrService: ToastrService,
    private readonly spinner: NgxSpinnerService
  ) {}

  ngOnInit(): void {
    if (this.showTip === "false") {
      this.showTip = false;
    }
    if (this.showCategoryToggle === "false") {
      this.showCategoryToggle = false;
    }
  }

  toggleView() {
    this.isCategoryView = !this.isCategoryView;
  }

  downloadTemplate(templateId: any, name: any) {
    this.assessmentCentralService.downloadTemplate(templateId).subscribe(
      (res: any) => {
        let downloadLink = document.createElement("a");
        downloadLink.href = window.URL.createObjectURL(res);
        downloadLink.setAttribute("download", name);
        document.body.appendChild(downloadLink);
        downloadLink.click();
        this.toastrService.success("Template downloaded successfully");
        this.spinner.hide();
      },
      (error: any) => {
        this.spinner.hide();
        throw error;
      }
    );
  }
  deleteTemplate(id: any, name: string) {
    const dialogRef = this.dialog.open(DeletePopupComponent, {
      data: name,
      disableClose: true,
      autoFocus: false,
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.assessmentCentralService.deleteTemplate(id).subscribe(() => {
          this.toastrService.success("Templated deleted successfully");
          // Remove id from unCategorizedTemplates
          this.unCategorizedTemplates = this.unCategorizedTemplates.filter(
            (item: any) => item.id !== id
          );
          // Remove id from filteredTemplate
          this.filteredTemplate.forEach((category: any) => {
            category.templates = category.templates.filter(
              (item: any) => item.id !== id
            );
          });
          // Remove empty categories from filteredTemplate
          this.filteredTemplate = this.filteredTemplate.filter(
            (category: any) => category.templates.length > 0
          );
          this.templateDeleted.emit(this.unCategorizedTemplates.length);
        });
      }
    });
  }

  getGMapRandomColor() {
    const maxHue = 360;
    return `hsla(${Math.floor(Math.random() * maxHue)}, 50%, 25%, 90%)`;
  }

  getTemplates() {
    this.filterAppliedStatus = false;
    this.templatesLoaded = false;
    this.assessmentCentralService.getTemplates().subscribe((res: any) => {
      res.forEach((category: any) => {
        category.templates.forEach((element: any) => {
          element.color = this.getGMapRandomColor();
        });
      });
      this.templates = res;
      this.filteredTemplate = res;
      this.unCategorizedTemplates = (
        this.filteredTemplate?.reduce(
          (acc: any, category: any) => [...acc, ...category.templates],
          []
        ) || []
      ).sort(
        (a: any, b: any) =>
          new Date(b.last_updated_on).getTime() -
          new Date(a.last_updated_on).getTime()
      );
      this.templatesLoaded = true;
      this.isDataLoaded = true;
    });
  }

  proceed(template: any) {
    const dialog = this.dialog.open(AssessmentCreateModalDialogComponent, {
      width: "500px",
      autoFocus: false,
      disableClose: true,
      data: {
        template_id: template.id,
        template_name: template.name,
        openFrom: this.openFrom,
      },
    });
    dialog.afterClosed();
  }

  previewAssessment(template: any, tags: any, categoriesList: any) {
    const dialog = this.dialog.open(AssessmentPreviewModalDialogComponent, {
      width: "50vw",
      disableClose: true,
      autoFocus: false,
      data: {
        dataKey: template,
        tagsList: tags,
        categoriesList,
      },
    });
    dialog.afterClosed().subscribe((data) => {
      if (data) {
        this.proceed(template);
      }
    });
  }

  editTemplate(template: any) {
    const dialogRef = this.dialog.open(AssessmentTemplateEditDialogComponent, {
      width: "90vw",
      maxWidth: "90vw",
      disableClose: true,
      autoFocus: false,
      data: {
        template,
      },
    });
    dialogRef.afterClosed().subscribe((updatedTemplate: any) => {
      if (!updatedTemplate) {
        return;
      }
      this.toastrService.success("Template updated successfully");

      // Preserve the old card's color, or generate one if unavailable
      updatedTemplate.color = template.color || this.getGMapRandomColor();

      // Old template is now inactive; new one replaces it in the lists.
      this.unCategorizedTemplates = this.unCategorizedTemplates
        .filter((item: any) => item.id !== template.id)
        .concat(updatedTemplate);
      if (this.filteredTemplate?.length) {
        this.filteredTemplate = this.filteredTemplate.map((cat: any) => ({
          ...cat,
          templates: cat.templates
            .filter((item: any) => item.id !== template.id)
            .concat(
              cat.type === updatedTemplate.type?.display_name ||
                cat.type === updatedTemplate.type
                ? [updatedTemplate]
                : []
            ),
        }));
      }
      this.templateDeleted.emit(this.unCategorizedTemplates.length);
    });
  }
}
